import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { buildCarbonIntensityNarrativeTokens } from './carbonIntensityNarrativeTokens';

const CHART_ID = 'carbon_intensity_of_electricity';
const VIEW_ID = 'default';

export interface CarbonIntensityNarrativeInput {
  locationName: string;
  latestYear: number;
  latestGco2ePerKwh: number;
  baselineYear: number;
  baselineGco2ePerKwh: number | null;
  percentChange: number | null;
  absoluteChange: number | null;
  sourceStatusSentence: string;
  hasInterpolatedYears?: boolean;
}

export function buildCarbonIntensityAuthoredBundle(input: CarbonIntensityNarrativeInput) {
  const tokens = buildCarbonIntensityNarrativeTokens(input);
  return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, tokens);
}

export function buildCarbonIntensityKeyInsights(input: CarbonIntensityNarrativeInput): string {
  const bundle = buildCarbonIntensityAuthoredBundle(input);
  return bundle.keyInsights || '';
}

export function carbonIntensityOverviewDescription(fallback: string): string {
  return getAuthoredOverview(CHART_ID, VIEW_ID, fallback);
}
